"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[2284],{

/***/ 2284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ navbar)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function navbar({ wrapper }) {
  const { classes } = window.config

    ; (function initEventListeners() {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', onScroll)
    })()

  function onScroll() {
    const scrollTop = getScrollTop()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).toggleClass(classes.active, scrollTop > 0)
  }

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop
  }
}


/***/ })

}]);